import { render, staticRenderFns } from "./ViewContentNotify.vue?vue&type=template&id=3bc40afa&scoped=true"
import script from "./ViewContentNotify.vue?vue&type=script&lang=js"
export * from "./ViewContentNotify.vue?vue&type=script&lang=js"
import style0 from "./ViewContentNotify.vue?vue&type=style&index=0&id=3bc40afa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc40afa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc40afa')) {
      api.createRecord('3bc40afa', component.options)
    } else {
      api.reload('3bc40afa', component.options)
    }
    module.hot.accept("./ViewContentNotify.vue?vue&type=template&id=3bc40afa&scoped=true", function () {
      api.rerender('3bc40afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/notify/ViewContentNotify.vue"
export default component.exports